 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import OEBPSCOVER from '@/components/OEBPS/cover'
 import OEBPSSS_US_ADULT_SIGNUP_FRONT from '@/components/OEBPS/SS_US_adult_signup_front'
 import LOVE_1 from '@/components/love_1'
 import OEBPSTITLE from '@/components/OEBPS/title'
 import OEBPSCOPY from '@/components/OEBPS/copy'
 import OEBPSDED from '@/components/OEBPS/ded'
 import OEBPSTOC from '@/components/OEBPS/toc'
 import OEBPSACK from '@/components/OEBPS/ack'
 import OEBPSINTRO from '@/components/OEBPS/intro'
 import OEBPSCH01 from '@/components/OEBPS/ch01'
 import OEBPSCH02 from '@/components/OEBPS/ch02'
 import OEBPSCH03 from '@/components/OEBPS/ch03'
 import OEBPSCH04 from '@/components/OEBPS/ch04'
 import OEBPSCH05 from '@/components/OEBPS/ch05'
 import OEBPSCH06 from '@/components/OEBPS/ch06'
 import OEBPSCH07 from '@/components/OEBPS/ch07'
 import OEBPSCH08 from '@/components/OEBPS/ch08'
 import OEBPSCH09 from '@/components/OEBPS/ch09'
 import OEBPSCH10 from '@/components/OEBPS/ch10'
 import OEBPSCH11 from '@/components/OEBPS/ch11'
 import OEBPSAPPA from '@/components/OEBPS/appa'
 import OEBPSAPPB from '@/components/OEBPS/appb'
 import OEBPSINDEX from '@/components/OEBPS/index'
 import OEBPSATA from '@/components/OEBPS/ata'
 import LOVE_2 from '@/components/love_2'
 import OEBPSSS_US_ADULT_SIGNUP_BACK from '@/components/OEBPS/SS_US_adult_signup_back'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/OEBPS/cover",
 			"name" : "OEBPS/cover",
 			"component" : OEBPSCOVER
 		},
 		{
 			"path" : "/OEBPS/SS_US_adult_signup_front",
 			"name" : "OEBPS/SS_US_adult_signup_front",
 			"component" : OEBPSSS_US_ADULT_SIGNUP_FRONT
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/OEBPS/title",
 			"name" : "OEBPS/title",
 			"component" : OEBPSTITLE
 		},
 		{
 			"path" : "/OEBPS/copy",
 			"name" : "OEBPS/copy",
 			"component" : OEBPSCOPY
 		},
 		{
 			"path" : "/OEBPS/ded",
 			"name" : "OEBPS/ded",
 			"component" : OEBPSDED
 		},
 		{
 			"path" : "/OEBPS/toc",
 			"name" : "OEBPS/toc",
 			"component" : OEBPSTOC
 		},
 		{
 			"path" : "/OEBPS/ack",
 			"name" : "OEBPS/ack",
 			"component" : OEBPSACK
 		},
 		{
 			"path" : "/OEBPS/intro",
 			"name" : "OEBPS/intro",
 			"component" : OEBPSINTRO
 		},
 		{
 			"path" : "/OEBPS/ch01",
 			"name" : "OEBPS/ch01",
 			"component" : OEBPSCH01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js